import React from "react";
import { GPTListContainer, GPTMessage } from "./GPTContentSuggestion.styles";
import { Box } from "@mui/material";
import { CommentAvatarGrid } from "../Comment.styles";
import { CheckGPTLogoIcon } from "@icons/CheckGPTLogoIcon";
import { ContentSuggestionsProps } from "./ContentSuggestion.types";

export const GPTContentSuggestion: React.FC<ContentSuggestionsProps> = ({
    suggestion,
}) => {
    return (
        <Box sx={{ paddingBottom: "12px" }}>
            <Box display={"flex"} width={"100%"}>
                <CommentAvatarGrid sx={{ paddingRight: "12px" }}>
                    <CheckGPTLogoIcon />
                </CommentAvatarGrid>
                <GPTListContainer>
                    <GPTMessage expanded={true}>
                        {suggestion.suggestionText}
                    </GPTMessage>
                    {suggestion.rank !== undefined && (
                        <Box sx={{ marginTop: "2px", fontSize: "14px" }}>
                            Rank: {suggestion.rank}
                        </Box>
                    )}
                </GPTListContainer>
            </Box>
        </Box>
    );
};
